import {useCallback} from "../../_snowpack/pkg/react.js";
import {useDispatch} from "../../_snowpack/pkg/react-redux.js";
import {sendMessage} from "../actions.js";
export function useSendMessage() {
  const dispatch = useDispatch();
  return useCallback((message) => dispatch(sendMessage(message)), [dispatch]);
}
